"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.avatar.exceeded': 'Avatar limit reached. Upgrade your plan to create more avatars.',
    'limits.avatar.limitReached': 'Avatar limit: {limit} (upgrade to create more)',
};
